module.exports = __webpack_public_path__ + "img/video9.fa9a6369.jpg";